import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-dialog-error-view',
    templateUrl: './dialog-error-view.component.html',
    styleUrls: ['./dialog-error-view.component.css'],
})
export class DialogErrorViewComponent implements OnInit {
    isHttpError: boolean;
    isErrorType: boolean;
    validationMsg: any[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public httpRspMessg: any,
        public dialogRef: MatDialogRef<DialogErrorViewComponent>
    ) {
        this.isHttpError = httpRspMessg instanceof HttpErrorResponse;
        this.isErrorType = httpRspMessg instanceof Error;
    }

    ngOnInit() {
        if (this.httpRspMessg && this.httpRspMessg.status == 400) {
            this.validationMsg = Object.values(this.httpRspMessg.error.message);
        }
        // this.closeDialog();
    }
    shouldShowGenericError(): boolean {
        return this.httpRspMessg?.status &&
            ![0, 400, 401, 429].includes(this.httpRspMessg.status);
    }
    closeDialog(): void {
        this.dialogRef.close();
    }
}
